// -------------------------- Modules --------------------
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Http cllient module
import { HttpClientModule } from '@angular/common/http';
// Routing module
import { RouterModule } from '@angular/router';

// -------------------------- Components --------------------
// Header Component
import { HeaderComponent } from './header/header.component';
// Footer Component
import { FooterComponent } from './footer/footer.component';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  declarations: [HeaderComponent, FooterComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    SharedModule
  ],

  exports: [HeaderComponent, FooterComponent]

})
export class CoreModule { }
